import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from 'recharts';

function CustomTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const d = payload[0]?.payload;
  return (
    <div style={{
      background: 'white',
      border: '1px solid #E8DFD2',
      borderRadius: '8px',
      padding: '10px 14px',
      fontSize: '0.82rem',
      boxShadow: '0 4px 12px rgba(92,74,58,0.1)',
    }}>
      <p style={{ fontWeight: 600, color: '#5C4A3A' }}>
        {d?.icon} {d?.category}
      </p>
      <p style={{ color: d?.fill }}>{d?.rate}% compliance</p>
    </div>
  );
}

export default function CategoryBreakdownChart({ data }) {
  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 5 }} barSize={36}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E8DFD2" vertical={false} />
        <XAxis
          dataKey="category"
          tick={{ fontSize: 11, fill: '#7A6651' }}
          tickLine={false}
          axisLine={{ stroke: '#E8DFD2' }}
        />
        <YAxis
          domain={[0, 100]}
          tick={{ fontSize: 11, fill: '#B8A48E' }}
          tickLine={false}
          axisLine={false}
          tickFormatter={(v) => `${v}%`}
        />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(184,164,142,0.1)' }} />
        <Bar dataKey="rate" radius={[4, 4, 0, 0]}>
          {data.map((entry, index) => (
            <Cell key={index} fill={entry.fill} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
